/**
 * This file provides the export for the shared PollTimerComponent.
 */
export * from './pollTimer.component';
